<template>
    <app-transition>
        <div class="overlay scrollable"  >
            <!-- <v-container fluid class="h-full p-0"> -->
                <v-row align="center" justify="center" class="h-full">
                    <v-col>
                        <div
                            class="DialogContent pa-6"
                            :class="{
                                'only-text': onlyText
                            }"
                        >
                            <div class="DialogContent-header">
                                <app-icon
                                    size="15"
                                    icon="close"
                                    :clickable="true"
                                    @click="handleClose"
                                ></app-icon>
                            </div>
                            <div class="DialogContent-body">
                                <div class="result-section text-center fade-in">
                                    <div class="result-icon mb-6">
                                        <template v-if="data.won">
                                            <reward-won-icon />
                                        </template>
                                        <v-icon v-else :size="130" color="grey">
                                            mdi-emoticon-sad-outline
                                        </v-icon>
                                    </div>
                                    <template v-if="data.won">
                                        <span>{{ $t('pages.user.setting.creator.mystery_box.you_won') }}</span>
                                        <h2 :class="data.won ? 'win-text' : 'lose-text'" class="mt-1">
                                            {{ data.result }}
                                        </h2>
                                        
                                        <p> {{ $t('pages.user.setting.creator.mystery_box.congratulaion_message', {
                                            result: data.result,
                                            name: creatorName
                                        }) }} </p>
    
                                        <button v-if="data.won && !data.is_requested" x-large class="claim-btn mt-3" :loading="claiming" @click="claimPrize">
                                            {{ $t('pages.user.setting.creator.mystery_box.request_prize') }}
                                        </button>
                                        <button v-else x-large class="claim-btn mt-3">
                                            {{ $t('pages.user.setting.creator.mystery_box.prize_requested') }}
                                        </button>
                                    </template>
                                    <template v-else>
                                        <h2 class="mt-1 lose-text">
                                            {{ $t('pages.user.setting.creator.mystery_box.won_nothing') }}
                                        </h2>
                                    </template>

                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            <!-- </v-container> -->
        </div>
    </app-transition>
</template>

<script>
import { mapActions } from "vuex";
import RewardWonIcon from "@/assets/images/icons/reward_won.svg?inline";

export default {
    name: "MysteryBoxRewardDialog",
    components: { RewardWonIcon },
    data: () => ({
        loading: false,
        opening: false,
        claiming: false,
        rewardTitle: null,
        showConfirmationPopUp: false,
        showResultScreen: false,
    }),
    props: {
        data: {
            type: Object,
            required: true,
        },
        won: {
            type: Boolean,
            required: true,
        },
        result: {
            type: String,
            required: true,
            default: 'You won nothing this time! Better luck for next time.',
        },
        reward: {
            type: String,
            default: ''
        },
        onlyText: {
            type: Boolean,
            default: false,
        },
        creatorName: {
            type: String,
            default: ''
        }
    },
    methods: {
        ...mapActions([

        ]),
        // async claimPrize() {
        //     this.claiming = true;
        //     await new Promise(r => setTimeout(r, 1000));
        //     this.showSnackBar("Prize requested! Message sent to creator.");
        //     this.claiming = false;
        // },

        handleClose() {
            this.$emit("close");
        },

        async claimPrize() {
            this.claiming = true;
            await new Promise(r => setTimeout(r, 1000));
            const model = {
                reward: this.data.reward,
                box_id: this.data.box_id,
            }
            this.claiming = false;
            this.$emit('requestReward', model)           

            this.$emit('close')
        },
    },
    mounted() {
        document.documentElement.classList.add('overflow-y-hidden');
    },
    beforeDestroy() {
        document.documentElement.classList.remove('overflow-y-hidden');
    }
}
</script>

<style scoped lang="scss">
@import "@/sass/modules/_variables";
    .result-section {
    .win-text {
        color: #2ecc71;
        font-weight: 700;
    }
    .lose-text {
        color: #666;
        font-weight: 600;
    }

    .claim-btn { width: 100%; height: 60px !important; font-weight: 700; font-size: 18px; line-height: 1; letter-spacing: -0.5px; text-align: center; background: linear-gradient(270.01deg, #FF7805 -20.74%, #FFA702 99.99%); color: rgba(0, 0, 0, 1); border-radius: 12px; padding: 22px 16px;
    }
    }

    .other-profile-wrapper .overlay { overflow: hidden; width: 100%; height: calc(100vh - 70px); display: flex; align-items: center; justify-content: center; position: absolute; position: absolute; top: 0; left: 0; padding: 24px; background: rgba(18, 18, 18, 0.58); backdrop-filter: blur(5px); }
    .other-profile-wrapper .overlay .DialogContent { background: rgba(29, 29, 29, 1); border-radius: 12px; border: 1px solid rgba(48, 48, 48, 1); padding: 25px; }
    .other-profile-wrapper .overlay .DialogContent-body .result-section span { background-image: linear-gradient(354.8deg, #FF7805 4.66%, #FFA702 83.25%); color: transparent; -webkit-background-clip: text; background-clip: text; font-weight: 700; font-size: 12px; line-height: 20px; letter-spacing: 4.2px; text-align: center; text-transform: uppercase; }
    .other-profile-wrapper .overlay .DialogContent-body .result-section h2 { font-weight: 800; font-size: 32px; line-height: 45px; letter-spacing: 0px; text-align: center; text-transform: capitalize; color: rgba(255, 255, 255, 1); }
    .other-profile-wrapper .overlay .DialogContent-body .result-section  p { color: rgba(255, 255, 255, 0.54); font-weight: 500;font-size: 16px;line-height: 26px;letter-spacing: 0px;text-align: center; }
    .other-profile-wrapper .overlay .DialogContent .DialogContent-header { text-align: end; }
</style>